import { ScreenLoading } from '@repo/ui';
import { useAuth } from 'presentation/app/hooks/useAuth';
import VerticalLayout from 'presentation/config/layouts/index';
import NonAuthLayout from 'presentation/config/layouts/NonAuthLayout';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Routes
import { PrivateRoutes, privateRoutes } from './privateRoutes';
import { publicRoutes } from './publicRoutes';
import { getEnv } from 'shared/get-env';

export const Router = () => {
  const { loadingGlobal } = useAuth();

  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
            />
          ))}
        </Route>
        <Route>
          {privateRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                loadingGlobal ? (
                  <ScreenLoading
                    imageHeight={'100vh'}
                    imageSrc={getEnv('REACT_APP_URL_LOGO')}
                  />
                ) : (
                  <PrivateRoutes>
                    <VerticalLayout>{route.component}</VerticalLayout>
                  </PrivateRoutes>
                )
              }
              key={idx}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};
